import RateOptionHeader from 'components/landing/top-rated-insurance/rate-option-header';
import styles from 'styles/LandingComponents.module.scss';
import { useTranslations } from 'next-intl';

const CheapCarHorizontalHeader = () => {
    const t = useTranslations('table.cheap-car-insurance.headers');
    return (
        <div className={styles.landing_range_table_horizontal_wrapper}>
            <RateOptionHeader
                label={t('car-insurance-company')}
                icon="shield"
            />
            <RateOptionHeader
                label={t('cheapest')}
                icon="cheapest-price"
                width={90}
            />
            <RateOptionHeader
                label={t('average')}
                icon="avg-price"
                width={90}
            />
            <RateOptionHeader
                label={t('maximum')}
                icon="maximum-price"
                width={90}
            />
        </div>
    );
};

CheapCarHorizontalHeader.propTypes = {};

export default CheapCarHorizontalHeader;
